import { student } from "../../constants/apiUrl";
import { IApiResponse } from "../../models/IAPIResponse";
import APIService from "../../helper/api-service";
import { IStudentGradeDetails } from "../../models/student/studentGradeDetail";
import { urlBinder } from "../../helper/url-binder";



export default new (class StudentGradeService {
  public getGradesDetails = async (studentId: string): Promise<IApiResponse<IStudentGradeDetails>> => {
    try {
      let endPoint = urlBinder(student.STUDENT_GRADE_DETAIL, [`${studentId}`]);
      const response = await APIService.get(endPoint);
      return response.data as IApiResponse<IStudentGradeDetails>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<IStudentGradeDetails>;
      } else {
        throw error;
      }
    }
  };
})();